import { render, staticRenderFns } from "./svcDiscountActivity.vue?vue&type=template&id=b3cc9ab2&"
import script from "./svcDiscountActivity.vue?vue&type=script&lang=js&"
export * from "./svcDiscountActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3cc9ab2')) {
      api.createRecord('b3cc9ab2', component.options)
    } else {
      api.reload('b3cc9ab2', component.options)
    }
    module.hot.accept("./svcDiscountActivity.vue?vue&type=template&id=b3cc9ab2&", function () {
      api.rerender('b3cc9ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/svcManage/svcDiscount/svcDiscountActivity.vue"
export default component.exports